import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

interface ReputationState {
  score: number;
  level: string;
  breakdown: Record<string, number>;
  history: any[];
  isLoading: boolean;
}

const initialState: ReputationState = {
  score: 0,
  level: 'citizen',
  breakdown: {},
  history: [],
  isLoading: false,
};

export const fetchReputation = createAsyncThunk(
  'reputation/fetch',
  async (_, { getState }) => {
    const state = getState() as { auth: { accessToken: string | null } };
    const response = await axios.get(
      `${API_BASE_URL}/users/me/reputation`,
      { headers: { Authorization: `Bearer ${state.auth.accessToken}` } }
    );
    return response.data.data.reputation;
  }
);

const reputationSlice = createSlice({
  name: 'reputation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReputation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReputation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.score = action.payload.score;
        state.level = action.payload.level;
        state.breakdown = action.payload.breakdown;
        state.history = action.payload.history;
      });
  },
});

export default reputationSlice.reducer;

